import endpoints from './api-endpoint-definition.json';
import { TrendingResource } from '../../_models/trending-resource';
import { ApiCall } from '@lcms/api-definition';

export type TrendingResourcesResponse = TrendingResource[]

const definition = new ApiCall<TrendingResourcesResponse>().get('trendingResources', {
    route: endpoints.trendingResources
})
export default definition;